import { Role } from '../enums/role';
import { Enterprise } from './enterprise';
import { Status } from './status';

export class SessionUser {
    public 'X-Auth-Key': string;
    public userId!: number;
    public userRoleId!: number;
    public walletId!: number;
    public name!: string;
    public email!: string;
    public role!: string;
    public success!: boolean;
    public status!: Status;
    public enterprise!: Enterprise;

    constructor(data: Partial<SessionUser> = {}) {
        this['X-Auth-Key'] = data['X-Auth-Key']!;
        this.name = data.name!;
        this.email = data.email!;
        this.userId = data.userId!;
        this.userRoleId = data.userRoleId!;
        this.walletId = data.walletId!;
        this.role = data.role!;
        this.enterprise = data.enterprise!;
        Object.assign(this, data);
    }

    public isAdmin() {
        return this.checkRole(Role.staff);
    }

    public isEnterprise() {
        return this.checkRole(Role.enterprise) || this.checkRole(Role.enterprise_contact);
    }

    public isSupplierEnterprise() {
        return this.isEnterprise() && this.enterprise?.supplier?.active;
    }

    public isWholesalerEnterprise() {
        return this.isEnterprise() && this.enterprise?.wholesaler?.active;
    }

    private checkRole(role: string) {
        if (this.role == role) {
            return true;
        }
        return false;
    }

    static deserialize(input: any): SessionUser {
        const user = new SessionUser();
        Object.assign(user, input);
        return user;
    }
}
